export const saveAuthorizationJwtTokenInLocalStorage = (authorizationToken) => {
  localStorage.setItem('authorization:jwtToken', authorizationToken);
};

export const saveAuthorizationRefreshTokenInLocalStorage = (refreshToken) => {
  localStorage.setItem('authorization:refreshToken', refreshToken);
};

export const loadAuthorizationJwtTokenFromLocalStorage = () => {
  return localStorage.getItem('authorization:jwtToken');
};

export const loadAuthorizationRefreshTokenFromLocalStorage = () => {
  return localStorage.getItem('authorization:refreshToken');
};

export const deleteAuthorizationJwtTokenFromLocalStorage = () => {
  localStorage.removeItem('authorization:jwtToken');
};

export const deleteAuthorizationRefreshTokenFromLocalStorage = () => {
  localStorage.removeItem('authorization:refreshToken');
};
